(() => {
  const hub = document.querySelector('[data-rehair-salon-hub]');
  if (!hub) return;

  const input = hub.querySelector('[data-salon-search]');
  const clearButton = hub.querySelector('[data-salon-clear]');
  const status = hub.querySelector('[data-salon-status]');
  const directory = document.querySelector('.rehair-salon-directory');

  if (!input || !clearButton || !status || !directory) return;

  const entries = Array.from(directory.querySelectorAll('.m-faqs-section__block-accordion'));

  const filterEntries = () => {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;

    entries.forEach((entry) => {
      const matches = !query || entry.textContent.toLowerCase().includes(query);
      entry.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    status.textContent = query
      ? `${visibleCount} location group${visibleCount === 1 ? '' : 's'} found`
      : `${entries.length} location groups available`;
  };

  input.addEventListener('input', filterEntries);
  clearButton.addEventListener('click', () => {
    input.value = '';
    filterEntries();
    input.focus();
  });

  filterEntries();
})();
